import Vue from "vue";
import { Toast } from 'vant';
import { Sticky } from 'vant';
import { Button } from 'vant';
import { CountDown } from 'vant';
import { Image } from 'vant';
import { Loading } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Field } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Cell, CellGroup } from 'vant';
import { Overlay } from 'vant';

Vue.use(Overlay);
Vue.use(Cell).use(CellGroup);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Loading);
Vue.use(Image);
Vue.use(CountDown);
Vue.use(Button);
Vue.use(Sticky);
Vue.use(Toast);
Vue.use(Swipe).use(SwipeItem);
Vue.use(Field);